import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { bindActionCreators } from 'redux';

import * as currentStatusActions from 'modules/currentStatus';
import * as examActions from 'modules/exam';

import { ExamChart } from 'components';

// let lineChartData = { before: {}, after: {} };

class CtExamChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChangeChart: false,
      isLoading: false
    };
    this.onLineChartTooltip = this.onLineChartTooltip.bind(this);
  }

  componentDidMount() {
    this.onGetExamChart();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      needReload,
      path,
      selectedExamSummaryNo,
      examSummaryOrdering,
      examSummaryByExamNo,
      selectedExamList
    } = this.props;

    if (selectedExamSummaryNo !== 'all') {
      if (
        // 훈련차트 정보가 변경되었을때
        (needReload && !this.state.isLoading) ||
        // url이 변경되었을 경우
        path.get('current') !== prevProps.path.get('current') ||
        // 선택한 훈련이 변경되었을 때
        selectedExamSummaryNo !== prevProps.selectedExamSummaryNo ||
        // 훈련의 데이터가 변경 되었을때
        examSummaryOrdering !== prevProps.examSummaryOrdering ||
        // 훈련의 데이터가 변경 되었을때
        examSummaryByExamNo !== prevProps.examSummaryByExamNo ||
        // 훈련 리스트에서 선택된 항목이 변경되었을때(전체 훈련일 경우에만)
        (selectedExamSummaryNo === 'all' && selectedExamList !== prevProps.selectedExamList)
      ) {
        this.onGetExamChart();
      }
    }
  }

  onGetExamChart = async () => {
    const { ExamActions } = this.props;
    this.setState({ isLoading: true });

    try {
      const { selectedExamSummaryNo, path } = this.props;

      if (selectedExamSummaryNo !== 'all') {
        const param = {
          examNo: selectedExamSummaryNo,
          subTab: path.get('current') === '/main/exam/pi' ? 'pi' : 'tag'
        };

        await ExamActions.getExamChart(param);
      }
      this.setState({ isLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  onPieEnter = (data, index) => {
    this.setState({
      activeIndex: index
    });
  };

  onLineChartTooltip = data => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const pd = data.payload;
    if (pd && pd.length > 0) {
      const content = [];
      pd.map((entry, index) => {
        const isPhishing = 4 === entry.payload.examType ? true : false;
        const name =
          (entry.name === 'target' && defineMessages(formatMessage({ id: 'CtExamChart_1', defaultMessage: '대상' }))) ||
          (entry.name === 'send' && defineMessages(formatMessage({ id: 'CtExamChart_2', defaultMessage: '발송' }))) ||
          (entry.name === 'read' && defineMessages(formatMessage({ id: 'CtExamChart_3', defaultMessage: '열람' }))) ||
          (entry.name === 'download' &&
            (isPhishing
              ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
              : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' })))) ||
          (entry.name === 'infection' &&
            (isPhishing
              ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
              : defineMessages(formatMessage({ id: 'CtExamChart_4', defaultMessage: '감염' })))) ||
          (entry.name === 'cure' && defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' })));

        const value = entry.payload[entry.name];

        if (
          entry.name === 'target' ||
          entry.name === 'send' ||
          entry.name === 'read' ||
          // 다운로드는 (피싱 페이지 or 링크 첨부가 포함 되어 있을때만)
          (entry.name === 'download' && (isPhishing || 2 & entry.payload.linkAttach)) ||
          entry.name === 'infection' ||
          // 치료는 악성 파일일때만 표시
          (entry.name === 'cure' && 1 === entry.payload.examType && 2 === entry.payload.attachExamType)
        ) {
          content.push(
            <div className="each-item" key={index}>
              <div className="color" style={{ backgroundColor: entry.color }} />
              <div className="message" title={name + ': ' + value}>
                <div className="message-name">{name}: </div>
                <div className="message-value">
                  {value > 99999 ? '+99999' : value}
                  {defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))}
                </div>
              </div>
            </div>
          );
        }
      });
      return (
        <div className="lineChart-tooltip custom-message">
          <div className="examName">{pd[0].payload.name}</div>
          {content}
        </div>
      );
    }
  };

  // 라인차트에서 hover 시 훈련 내용
  // onLineChartMove = () => {
  //   if (lineChartData['before'] !== lineChartData['after']) {
  //     this.setState({ isChangeChart: true });
  //     lineChartData['before'] = lineChartData['after'];
  //   } else if (!!this.state.isChangeChart) {
  //     this.setState({ isChangeChart: false });
  //   }
  // };

  render() {
    const {
      selectedExamSummaryNo,
      selectedExamList,
      examSummaryOrdering,
      examSummaryByExamNo,
      examListByNo,
      path,
      examChart
    } = this.props;
    const { onPieEnter, onLineChartTooltip } = this;

    // 랜더링 되기 전에 lineChartData['after']에 처음에 데이터를 입력해야함
    // if (Object.keys(lineChartData['after']).length === 0 && examSummaryOrdering.size > 0) {
    //   lineChartData['after'] = examSummaryByExamNo.get(String(examSummaryOrdering.get(0))).toJS();
    // }

    return (
      selectedExamSummaryNo !== 'all' ?
        <ExamChart
          currentPath={path.get('current')}
          examChart={examChart}
          // lineChartData={lineChartData}
          selectedExamSummaryNo={selectedExamSummaryNo}
          selectedExamList={selectedExamList}
          examSummaryOrdering={examSummaryOrdering}
          examSummaryByExamNo={examSummaryByExamNo}
          examListByNo={examListByNo}
          onPieEnter={onPieEnter}
          onLineChart={{
            isChangeChart: this.state.isChangeChart,
            tooltip: onLineChartTooltip
            //  move: onLineChartMove
          }}
        /> : <div></div>
    );
  }
}

const mapStateToProps = state => ({
  examChart: state.exam.get('chart'),
  examSummaryOrdering: state.examSummary.get('examSummaryOrdering'),
  examSummaryByExamNo: state.examSummary.get('examSummaryByExamNo'),
  examListByNo: state.examList.get('examListByNo'),
  selectedExamSummaryNo: state.currentStatus.getIn(['examSummary', 'selected']),
  selectedExamList: state.currentStatus.getIn(['examList', 'selected', 'noArray']),
  path: state.currentStatus.get('path'),
  needReload: state.exam.getIn(['chart', 'needReload'])
});

const mapDispatchToProps = dispatch => ({
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ExamActions: bindActionCreators(examActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamChart));



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtExamChart.js